import { useEffect, useState } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./Dashboard";
import LoginPage from "./components/LoginPage";
import DistributorProfile from "./components/DistributorProfile";
import api from "./services/api";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => sessionStorage.getItem("isLoggedIn") === "true");
  const [email, setEmail] = useState(sessionStorage.getItem("email") || "");
  const [profileStatus, setProfileStatus] = useState("checking"); // checking | incomplete | complete

  const handleLoginSuccess = (loginData) => {
    setIsLoggedIn(true);
    setEmail(loginData.email || "");
    sessionStorage.setItem("isLoggedIn", "true");
    sessionStorage.setItem("email", loginData.email || "");
    if (loginData.accessToken) sessionStorage.setItem("accessToken", loginData.accessToken);
    if (loginData.refreshToken) sessionStorage.setItem("refreshToken", loginData.refreshToken);
    if (loginData.userId !== undefined) sessionStorage.setItem("userId", String(loginData.userId));
    if (loginData.distributorId !== undefined && loginData.distributorId !== null) {
      sessionStorage.setItem("distributorId", String(loginData.distributorId));
    }
    if (loginData.role) sessionStorage.setItem("role", loginData.role);
    setProfileStatus("checking");
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setEmail("");
    setProfileStatus("checking");
    sessionStorage.clear();
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    let cancelled = false;
    const checkProfile = async () => {
      try {
        const data = await api.get("/api/v1/distributor-profile");
        if (!cancelled) setProfileStatus(data?.exists ? "complete" : "incomplete");
      } catch (error) {
        // SUPER_ADMIN with no distributor scope, or a transient error — don't block the whole app on this
        if (!cancelled) setProfileStatus("complete");
      }
    };
    checkProfile();
    return () => {
      cancelled = true;
    };
  }, [isLoggedIn]);

  const renderLoggedInArea = () => {
    if (profileStatus === "checking") {
      return (
        <div className="loading-overlay" style={{ position: "fixed" }}>
          <div className="spinner-card">
            <div className="spinner-ring" />
            <div className="spinner-label">Loading...</div>
          </div>
        </div>
      );
    }
    if (profileStatus === "incomplete") {
      return (
        <div style={{ position: "relative" }}>
          <button
            className="secondary"
            style={{ position: "fixed", top: "16px", right: "16px", zIndex: 10 }}
            onClick={() => {
              handleLogout();
              toast.info("Logged out");
            }}
          >
            Logout
          </button>
          <DistributorProfile mode="mandatory" onComplete={() => setProfileStatus("complete")} />
        </div>
      );
    }
    return <Dashboard email={email} onLogout={handleLogout} />;
  };

  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? <Navigate to="/dashboard" /> : <LoginPage onLoginSuccess={handleLoginSuccess} />
          }
        />
        <Route
          path="/dashboard/*"
          element={isLoggedIn ? renderLoggedInArea() : <Navigate to="/" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
